import { render, staticRenderFns } from "./PCPDropdown.vue?vue&type=template&id=597d382b&scoped=true&"
import script from "./PCPDropdown.vue?vue&type=script&lang=js&"
export * from "./PCPDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PCPDropdown.vue?vue&type=style&index=0&id=597d382b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d382b",
  null
  
)

export default component.exports